import React, { Fragment, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FcFile } from "react-icons/fc";
import { Button } from 'primereact/button';
import { theme } from '../../theme/theme';
import IconInputText from '../../component/iconInputText/iconInputText';


const FileExplorerFile = ({ label, backClick, onFileClick, closeDialog, loading, fileLabelKey, file }) => {

  const [searchVal, setSearchVal] = useState("")
  return (
    <div>
      <Dialog
        visible={true}
        style={{ width: '80%' }}
        header={<Fragment><div className='grid'>
          <div className='col-6' style={{overflowWrap:"anywhere"}}>
            {label}
          </div>
          <div className='col-6'>
            <IconInputText iconPosition="left" style={{ width: "100%", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search File" />
          </div>
        </div></Fragment>}
        modal
        onHide={closeDialog}
      >
        {loading ? <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div> :
          <Fragment>
            <Button onClick={backClick} style={{ backgroundColor: "transparent", border: "none", color: theme.colors.primary }} icon="pi pi-arrow-left" />
            <div className='grid' style={{ padding: "15px" }}>

              {searchVal === "" ? file.map((val) => {
                return <div className='col-3'><Fragment>
                  <FcFile size={40} className='handCursor' onClick={() => {
                    onFileClick(val)
                    closeDialog()
                  }
                  } />
                  <div style={{ overflowWrap: "anywhere" }}>{fileLabelKey !== undefined && fileLabelKey !== null ? val[fileLabelKey] : val}</div>
                </Fragment>
                </div>
              }) :
                file.filter((val1) => val1.toLowerCase().includes(searchVal.toLowerCase())).map((val) => {
                  return <div className='col-3'><Fragment>
                    <FcFile size={40} className='handCursor' onClick={() => {
                      onFileClick(val)
                      closeDialog()
                    }
                    } />
                    <div style={{ overflowWrap: "anywhere" }}>{fileLabelKey !== undefined && fileLabelKey !== null ? val[fileLabelKey] : val}</div>
                  </Fragment>
                  </div>
                })}

            </div>
          </Fragment>
        }
      </Dialog>
    </div>
  );
};

export default FileExplorerFile;
